import BaseClass from "../BaseClass";
import {PushSubscription} from "./PushSubscription";

export class PushSubscriptionManager extends BaseClass
{
    constructor(element) {
        super(element);

        this.pushSubscription = null;

        this.endpoint = null;
        this.subscriptionEndpointExists = null;

        this.init();
    }

    async init() {
        this.pushSubscription = new PushSubscription();

        if (this.pushSubscription.arePushNotificationsSupported()) {
            await this.pushSubscription.initiateServiceWorker();

            // Early Exit, falls die Permission nicht gegeben wurde.
            if (Notification.permission === 'denied') {
                return;
            }

            // Checke, ob User in Notification Override braucht oder ob die PushSubscription in der DB nicht existiert
            if (Notification.permission === 'granted') {
                this.endpoint = await this.pushSubscription.getLocalPushSubscriptionEndpoint();

                // Fahre fort, wenn es bereits einen Endpunkt gibt
                if (this.endpoint !== null) {
                    this.subscriptionEndpointExists = await this.pushSubscription.checkPushSubscription(this.endpoint);

                    // Schreibe die Subscription in die DB, falls sie dort noch nicht existiert
                    if (!this.subscriptionEndpointExists) {
                        const subscription = await this.pushSubscription.prepareSubscription();

                        // Schicke die Subscription an den Server
                        await this.pushSubscription.sendSubscriptionToServer(subscription);
                        return;
                    }

                    await this.pushSubscription.overwriteUserForExistingEndpoint();
                    return;
                }
            }

            if (this.pushSubscription.canAskForPermission() && Notification.permission === 'default') {
                this.openModal('/push-subscriptions/settings/push_subscription_form');
                return;
            }

            return;
        }

        // Wenn ein Apple Gerät nicht als PWA im display-mode standalone läuft und Push-Notifications nicht unterstütz werden
        // Dann zeige das Modal für die Apple-Info an
        if (!this.pushSubscription.checkStandaloneMode() && this.pushSubscription.isAppleDevice() && this.pushSubscription.canShowInfo()) {
            this.openModal('/push-subscriptions/settings/push_subscription_informative_form');
        }
    }
}